import { useEffect } from 'react';

var useScrollLock = function useScrollLock(locked, element) {
  var preventBodyScroll = function preventBodyScroll(event) {
    if (!element.contains(event.target)) {
      event.preventDefault();
    }
  };

  var addListeners = function addListeners() {
    document.querySelector('html').classList.add('modal_open');
    document.querySelector('body').classList.add('modal_open');
    document.body.addEventListener('touchmove', preventBodyScroll, {
      passive: false
    });
  };

  var removeListeners = function removeListeners() {
    document.querySelector('html').classList.remove('modal_open');
    document.querySelector('body').classList.remove('modal_open');
    document.body.removeEventListener('touchmove', preventBodyScroll, {
      passive: false
    });
  };

  useEffect(function () {
    if (locked) {
      addListeners();
    } else {
      removeListeners();
    }

    return function () {
      removeListeners();
    };
  });
};

export default useScrollLock;
//# sourceMappingURL=useScrollLock.js.map